var b = Object.defineProperty;
var J = (o, t, e) => t in o ? b(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var i = (o, t, e) => J(o, typeof t != "symbol" ? t + "" : t, e);
import { L as u } from "./layout-Do4l8J3p.mjs.js";
import { B as x } from "./base-CMhGIFuX.mjs.js";
import { j as c, c as y } from "./client-zRtiouUI.mjs.js";
class I extends x {
  constructor() {
    super(...arguments);
    i(this, "apiKey", "");
    i(this, "version");
    i(this, "cioOptions");
    /** Pre filter expressions from Shopify section settings that affects all collections*/
    i(this, "sectionPreFilters", []);
    /** Pre filter expressions from collection metafield that affects specific collection, and overrides sectionPreFilters */
    i(this, "metafieldPreFilters");
    /** Houzz configs for controlling this widget, such as show_filter_pills and show_result_count */
    i(this, "config");
  }
  async connectedCallback() {
    await super.connectedCallback(), this.apiKey = this.dataset.apiKey || "", this.version = this.dataset.version, this.cioOptions = this.getJson("cio-options"), this.sectionPreFilters = this.getJson("section-pre-filters") || [], this.metafieldPreFilters = this.getJson("metafield-pre-filters"), this.config = this.getJson("config");
  }
}
class F extends I {
  constructor() {
    super(...arguments);
    i(this, "categoryIds", []);
    i(this, "productIds", []);
  }
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.dataset.filterName || "group_id", a = this.dataset.filterValue || "all";
    this.categoryIds = this.parseJson(this.dataset.categoryIds) || [], this.productIds = this.parseJson(this.dataset.productIds) || [];
    let s = {
      ...this.cioOptions
    }, n = {
      filterName: e,
      filterValue: a
      // options,
    }, r;
    this.categoryIds.length > 0 ? this.categoryIds.length > 1 ? r = {
      or: this.categoryIds.map((d) => ({
        name: "current_category_int",
        value: d.toString()
      }))
    } : n = {
      filterName: "group_id",
      filterValue: this.categoryIds[0].toString()
    } : this.productIds.length > 0 && (n = {
      itemIds: this.productIds
    });
    const p = this.metafieldPreFilters?.pre_filters || [], h = this.metafieldPreFilters?.search_query || "", l = [...this.sectionPreFilters, ...p];
    l.length > 0 && r ? s.preFilterExpression = {
      and: [...l, r]
    } : l.length > 0 ? s.preFilterExpression = {
      and: l
    } : r && (s.preFilterExpression = r);
    const C = {
      apiKey: this.apiKey,
      version: this.version
    }, g = this.getJson("topsort-configuration");
    let f;
    g && (f = {
      apiKey: g.apiKey,
      slots: g.slots,
      categoryId: this.categoryIds?.[0]?.toString()
    });
    let m;
    if (h) {
      const {
        CioSearch: d
      } = await import("./cioSearch-BbcrmbCG.mjs.js");
      m = /* @__PURE__ */ c.jsx(d, {
        query: h,
        topsort: f,
        options: s,
        config: this.getJson("config"),
        ...C
      });
    } else {
      const {
        CioBrowse: d
      } = await import("./cioBrowse-DtO50tg2.mjs.js");
      m = /* @__PURE__ */ c.jsx(d, {
        browsePaths: n,
        topsort: f,
        options: s,
        config: this.getJson("config"),
        ...C
      });
    }
    y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: m
    }));
  }
}
customElements.get("cio-browse") || customElements.define("cio-browse", F);
class P extends I {
  async connectedCallback() {
    await super.connectedCallback();
    const {
      CioSearch: t
    } = await import("./cioSearch-BbcrmbCG.mjs.js"), e = this.dataset.query || "";
    let a = {
      ...this.cioOptions
    };
    this.sectionPreFilters.length > 0 && (a.preFilterExpression = {
      and: this.sectionPreFilters
    });
    const s = this.getJson("topsort-configuration");
    let n;
    s && (n = {
      apiKey: s.apiKey,
      slots: s.slots
    }), y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: /* @__PURE__ */ c.jsx(t, {
        query: e,
        topsort: n,
        options: a,
        apiKey: this.apiKey,
        version: this.version,
        config: this.getJson("config")
      })
    }));
  }
}
customElements.get("cio-search") || customElements.define("cio-search", P);
class w extends x {
  async connectedCallback() {
    await super.connectedCallback();
    const t = this.dataset.apiKey || "", e = this.dataset.version, a = this.dataset.podId || "", s = this.getJson("cio-options"), n = this.getJson("carousel-options");
    if (!t) {
      this.innerHTML = "Constructor API key is required";
      return;
    }
    if (!a) {
      this.innerHTML = "Pod ID is required";
      return;
    }
    const r = {
      autoplay: Number(this.dataset.autoplay),
      css: {
        root: this.dataset.cssRoot,
        content: this.dataset.cssContent,
        item: this.dataset.cssSlide,
        prevBtn: this.dataset.cssPrevBtn,
        nextBtn: this.dataset.cssNextBtn,
        dots: this.dataset.cssDots,
        dot: this.dataset.cssDot
      },
      ...n
    }, p = this.getJson("config"), {
      CioRecommendations: h
    } = await import("./cioRecommendations-BD9zTbxz.mjs.js");
    y.createRoot(this).render(/* @__PURE__ */ c.jsx(u, {
      children: /* @__PURE__ */ c.jsx(h, {
        carouselProps: r,
        podId: a,
        cioOptions: s,
        config: p,
        apiKey: t,
        version: e
      })
    }));
  }
}
customElements.get("cio-recommendations") || customElements.define("cio-recommendations", w);
